<dgx-components-grid-section>
  <dgx-components-grid-container>
    <dgx-components-grid-row>
      <dgx-components-grid-column [xs]="12">
        <dgx-components-content
          [body]="body"
          [intro]="intro"
          [textAlign]="textAlign"
          [title]="title"
          class="contact-us-panel-block__content"
        />
      </dgx-components-grid-column>
    </dgx-components-grid-row>

    <dgx-components-grid-row>
      <dgx-components-grid-column class="contact-us-panel-block__panels">
        <div
          *ngFor="let panel of panels | cmsContent"
          class="contact-us-panel-block__panel"
        >
          <support-contact-us-panel
            [body]="panel.body"
            [icon]="panel.icon"
            [link]="panel.link"
            [title]="panel.title"
          />
        </div>
      </dgx-components-grid-column>
    </dgx-components-grid-row>
  </dgx-components-grid-container>
</dgx-components-grid-section>
